module.exports = flarum.core.compat['components/SessionDropdown'];